import { useParams } from "react-router";
import { Id } from "@convex/_generated/dataModel";
import { BlockDetailPage } from "@/components/blocks/block-detail-page";

export default function BlockPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-muted-foreground">Block not found</p>
      </div>
    );
  }

  const blockId = id as Id<"blocks">;

  return <BlockDetailPage blockId={blockId} />;
}
